module.exports = __webpack_public_path__ + "img/sub_support_4.eeb071b3.png";